// @flow
import TeamPlayers from 'components/team/TeamPlayers';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/team/TeamPlayers';
import { fetchTeamList } from 'actions/teamlistActions';
import { fetchPageList } from 'actions/pageActions';
import { fetchJoueursTeam, initialFetchJoueursTeam, resetJoueur } from 'actions/joueurActions';
import { searchPlayer } from 'actions/filterOptionsActions';

export default connect(
  (state: StateType): StateProps => ({
    title: state.pageListState.title,
    excerpt: state.pageListState.excerpt,
    featured_media: state.pageListState.featured_media,
    meta_title: state.pageListState.meta_title,
    meta_description: state.pageListState.meta_description,
    sidebar_content: state.pageListState.sidebar_content,
    joueursFetchStatus: state.joueurState.status,
    joueurs: state.joueurState.joueurs,
    status: state.pageListState.status,
    searchedPlayer: state.filterOptionsState.searchedPlayer,
    defaultSeason: state.filterOptionsState.defaultSeason,
    seasons: state.seasonsState.seasons,
    teamlist: state.teamlistState.teamlist,
    redirect_competitions: state.pageListState.redirect_competitions,
    redirect_resultats: state.pageListState.redirect_resultats
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
    fetchJoueursTeam: (filters: Object) => dispatch(fetchJoueursTeam(filters)),
    searchPlayer: (searchedPlayer: string) => dispatch(searchPlayer(searchedPlayer)),
    initialFetchJoueursTeam: (filters: Object) => dispatch(initialFetchJoueursTeam(filters)),
    fetchTeamList: () => dispatch(fetchTeamList()),
    resetJoueur: () => dispatch(resetJoueur())
  })
)(TeamPlayers);
